/**
 * VR setup panel: detect height from xrCamera Y, allow ±20cm slider correction, persist.
 * TODO: implement panel rendering + slider interaction. Stub for Q12 flow step 1.
 */
import {
  HEIGHT_DETECT_CAMERA_OFFSET_M,
  USER_HEIGHT_DEFAULT_CM,
  USER_HEIGHT_LOAD_MAX_CM,
  USER_HEIGHT_LOAD_MIN_CM,
} from '../config/constants';
import { getSetting, setSetting } from '../settings/userSettings';

export function loadUserHeightCm(): number {
  const v = getSetting('userHeightCm');
  return Number.isFinite(v) && v >= USER_HEIGHT_LOAD_MIN_CM && v <= USER_HEIGHT_LOAD_MAX_CM
    ? v
    : USER_HEIGHT_DEFAULT_CM;
}

export function saveUserHeightCm(cm: number): void {
  setSetting('userHeightCm', Math.round(cm));
}

export function detectHeightFromCameraY(cameraYMeters: number): number {
  return Math.round((cameraYMeters + HEIGHT_DETECT_CAMERA_OFFSET_M) * 100);
}
